import React from 'react';

function Services() {
  return (
    <section
      className="tc-services-style1"
      style={{
        padding: '60px 0 40px 0',
        backgroundColor: '#fff',
        position: 'relative',
        zIndex: 10,
      }}
    >
      <div className="content section-padding-x">
        <div className="container">
          <div style={{ textAlign: 'center' }}>
            <p style={{ fontWeight: 'bold', fontSize: '18px', lineHeight: '1.6', marginBottom: '20px' }}>
                We are a full-service metal fabrication shop serving the Greater Phoenix area. Our capabilities span from architectural elements and installations for the commercial and luxury residential sectors, to industrial fabrication and product manufacturing
            </p>
            <a
              href="/about"
              className="butn border rounded-pill color-orange1 border-orange1 hover-bg-orange1"
            >
            <span>
              More About Us
              <i className="small ms-1 ti-arrow-top-right"></i>
            </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;